var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStaffUnknown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.5,
    height: 36,
    viewBox: "0 0 45.5 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3925",
    "data-name": "Group 3925",
    transform: "translate(4906 -673)",
    opacity: 0.301
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8547",
    "data-name": "Path 8547",
    d: "M694.135,802.938a16.6,16.6,0,0,0-1.013-2.232,3.838,3.838,0,0,0-2.513-2.027,30.623,30.623,0,0,0-5.968-.976c-.182-.014-.364-.022-.546-.041a.9.9,0,0,1-.2-.084c0-.893-.009-1.8.009-2.709a.647.647,0,0,1,.2-.364,9.58,9.58,0,0,0,2.017-3.286c.058-.152.247-.254.377-.378.182-.17.425-.3.535-.513a4.694,4.694,0,0,0,.458-3.284.984.984,0,0,0-.843-.883c-.272-2,.12-3.977-.951-5.851s-4.181-2.272-5.712-2.28c-1.532.008-4.616.506-5.686,2.38s-.7,3.75-.97,5.75a.984.984,0,0,0-.843.883,4.683,4.683,0,0,0,.458,3.284c.11.213.353.343.535.513.13.124.32.226.377.378a9.564,9.564,0,0,0,2.017,3.286.656.656,0,0,1,.2.364c.018.909.009,1.817.009,2.709a.946.946,0,0,1-.2.084c-.182.019-.364.026-.546.041a30.611,30.611,0,0,0-5.977.977,3.833,3.833,0,0,0-2.513,2.027,16.352,16.352,0,0,0-1.013,2.232c-.453,1.391-.806,2.811-1.224,4.3h30.75C694.941,805.749,694.588,804.329,694.135,802.938ZM680.6,792.458a1.189,1.189,0,0,1-.875.311,1.228,1.228,0,0,1-.889-.3,1.352,1.352,0,0,1-.007-1.727,1.247,1.247,0,0,1,.9-.294,1.215,1.215,0,0,1,.878.3,1.329,1.329,0,0,1,0,1.712Zm2.255-6.231a4.867,4.867,0,0,1-1.3,1.231,3.971,3.971,0,0,0-.831.738,1.15,1.15,0,0,0-.174.663v.41h-1.812v-.505a2.24,2.24,0,0,1,.28-1.142,3.673,3.673,0,0,1,1.026-1.032,4.325,4.325,0,0,0,.947-.834,1.211,1.211,0,0,0,.229-.718.779.779,0,0,0-.329-.677,1.56,1.56,0,0,0-.916-.232,5.253,5.253,0,0,0-2.337.67l-.746-1.5a6.515,6.515,0,0,1,3.234-.855,3.441,3.441,0,0,1,2.239.677,2.212,2.212,0,0,1,.83,1.8A2.4,2.4,0,0,1,682.856,786.227Z",
    transform: "translate(-5563.609 -102.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2227",
    "data-name": "Rectangle 2227",
    transform: "translate(-4906 673)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5,
    opacity: 0.998
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.5,
    height: 36,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 44,
    height: 34.5,
    rx: 5.25,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStaffUnknown);
export default __webpack_public_path__ + "static/media/icon-staff-unknown.79384586a7f0881b0e2e2b1c1f8adebb.svg";
export { ForwardRef as ReactComponent };